/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-17T17:39:58.444
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getReportMonthRentContractUndueEditInit,
	getReportMonthRentContractUndueView
} from '@api/report/ReportMonthRentContractUndue';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getReportMonthRentContractUndueEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportMonthRentContractUndueEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportMonthRentContractUndueView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportMonthRentContractUndueView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
